export default function changeObjectPlans() {
  const isPresent = document.querySelector(".js-panzoom-el");
  if (!isPresent) {
    return;
  }

  const buttons = document.querySelectorAll(".object-plan-select");
  const imgElements = document.querySelectorAll(".js-panzoom-el");

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      // Get the data-object-plan-url value of the clicked button
      const newImageUrl = button.getAttribute("data-object-plan-url");

      // Update the img src attribute
      if (imgElements) {
        imgElements.forEach((imgElement) => {
          imgElement.setAttribute("src", newImageUrl);
        });
      }
    });
  });
}
